import {Box, Typography} from "@mui/material";
import React from "react";
import {useLanguage} from "../../../LanguageContext";


export const AdventureTextComponent = () => {
    const {t} = useLanguage();

    return (
        <Box
            sx={{
                textAlign: 'center',
                pl: '20px',
                pr: '20px',
            }}>
            <Typography sx={{
                fontSize: '20px',
                mb: 2,
                color: '#333',
                fontFamily: 'Jost-Regular',
            }}>
                {t('label_adventure_text')}
            </Typography>
        </Box>
    );
}
